/* ================================================
   memorialball — Shopify Dawn 用スコープ済み JS
   .memorialball 配下の要素のみ対象
================================================ */

(function () {
  'use strict';

  const root = document.querySelector('.memorialball');
  if (!root) return;

  /* --- FAQ アコーディオン ----------------------- */
  root.querySelectorAll('.faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answer   = btn.nextElementSibling;

      root.querySelectorAll('.faq__q').forEach(function (q) {
        q.setAttribute('aria-expanded', 'false');
        var a = q.nextElementSibling;
        if (a) a.classList.remove('open');
      });

      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        if (answer) answer.classList.add('open');
      }
    });
  });

  /* --- スクロール表示（IntersectionObserver） --- */
  var fadeEls = root.querySelectorAll('.fade-up');

  if (fadeEls.length > 0 && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    fadeEls.forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 0.08 + 's';
      io.observe(el);
    });
  }

  /* --- スムーススクロール（アンカーリンク） ------ */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var stickyHeader = document.querySelector('.header-wrapper, .shopify-section-header-sticky');
      var navH = stickyHeader ? stickyHeader.offsetHeight : 68;
      var top  = target.getBoundingClientRect().top + window.scrollY - navH;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

})();
